import { notifications } from "@mantine/notifications";
import { User } from "@sentry/react";
import { useQuery } from "@tanstack/react-query";
import { PropsWithChildren, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authContext } from "../contexts/auth";

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const [name, setName] = useState("");
  const { data } = useQuery<User>({
    queryKey: ["user"],
    queryFn: async () => {
      const resp = await fetch("/api/user/me");
      return resp.json();
    },
    refetchOnWindowFocus: false
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setName(data.name);
    }
  }, [data]);

  const logout = async () => {
    const resp = await fetch("/api/auth/logout", { method: "POST" });
    if (!resp.ok) {
      console.error("Failed to log out");
    }
    notifications.show({
      variant: "success",
      message: "Logged Out!"
    });
    setName("");
    navigate("/");
  };

  return (
    <authContext.Provider
      value={{
        name,
        logout
      }}
    >
      {children}
    </authContext.Provider>
  );
};
